import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';

@Component({
  selector: 'app-salary-claim-pop-up',
  templateUrl: './salary-claim-pop-up.component.html',
  styleUrls: ['./salary-claim-pop-up.component.scss']
})
export class SalaryClaimPopUpComponent implements OnInit {

  delivery: Delivery;
  deliveryClaimForm: any;
  disableBtn: boolean = false;
  formValidationMsgs: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
    private dialogRef: MatDialogRef<SalaryClaimPopUpComponent>,
    private deliveryService: DeliveryService,
    private commanUsesService: CommanUsesService,
    private fb: FormBuilder,
  ) { 
    this.formValidationMsgs = {
      'complaintText': [
        { type: 'required', message: 'Obbligatorio' },
      ],
    }
    this.delivery = this.data.delivery;
    this.deliveryClaimForm = this.fb.group({
      complaintText: ['', Validators.required]
    });
  }

  ngOnInit() {}

  async onSubmit(){
    try {
      this.disableBtn = true;
      if(this.deliveryClaimForm.valid) {
        let promise = this.deliveryService.complainForDeliverySalary(this.delivery.id, this.deliveryClaimForm.value);
        promise.then((res) => {
          if(res) {
            this.commanUsesService.showSnackBar("Claim email has been sended");
            this.disableBtn = false;
            this.dialogRef.close(true);
          } else {
            this.commanUsesService.showSnackBar("Something went wrong");  
          }
        }).catch((err) => {
          let errorMsg: string = ``;
          if(err.error.message === "COMPLAIN_EMAIL_EMPTY") {
            errorMsg = `L'EMAIL DI AMMINISTRAZIONE NON È ANCORA IMPOSTATA`;
          } else {
            errorMsg = err.error.message;
          }
          this.commanUsesService.showSnackBar(errorMsg);
          this.disableBtn = false;
        });
      }
    } catch (error) {
      
    }
  }
  

}
